'use client';

import React, { useState } from 'react';
import { Box, VStack, Button, Image } from '@skin-seoul/design-system';
import { overlay } from 'overlay-kit';
import LearnMoreModal from './components/LearnMoreModal';
import SectionContainer from '../../components/SectionContainer';
import { useProductService, useRegionCurrency } from '@skin-seoul/service';
import { useParams } from 'next/navigation';
import { ClientOnly } from '@skin-seoul/utils';
const LearnMoreWithVisualsSection = () => {
  const {
    useGetProductsDetail
  } = useProductService();
  const {
    currency
  } = useRegionCurrency();
  const params = useParams();
  const [hasImageError, setHasImageError] = useState(false);
  const {
    data: {
      product
    }
  } = useGetProductsDetail({
    slug: params.slug as string,
    currency
  });
  const handleLoadMore = () => {
    overlay.open(({
      isOpen,
      close
    }) => <LearnMoreModal isOpen={isOpen} onClose={close} imageUrls={product.learnMoreUrl || []} />);
  };
  const handleImageError = () => {
    setHasImageError(true);
  };
  const firstProductImage = product?.learnMoreUrl?.[0];
  if (!firstProductImage || hasImageError) {
    return null;
  }
  return <SectionContainer headerTitle="Learn More with Visuals" data-sentry-element="SectionContainer" data-sentry-component="LearnMoreWithVisualsSection" data-sentry-source-file="LearnMoreWithVisualsSection.tsx">
      <VStack gap={0} width="100%" alignItems="stretch" data-sentry-element="VStack" data-sentry-source-file="LearnMoreWithVisualsSection.tsx">
        {/* Image Container */}
        <Box position="relative" width="100%" height={{
        base: '240px',
        tablet: '385px'
      }} borderRadius={{
        base: '8px 8px 0 0',
        tablet: '8px 8px 0 0'
      }} overflow="hidden" background="white" data-sentry-element="Box" data-sentry-source-file="LearnMoreWithVisualsSection.tsx">
          <Box top="0" data-sentry-element="Box" data-sentry-source-file="LearnMoreWithVisualsSection.tsx">
            <ClientOnly data-sentry-element="ClientOnly" data-sentry-source-file="LearnMoreWithVisualsSection.tsx">
              <Image src={firstProductImage} alt="Learn More with Visuals" width="100%" height="100%" onError={handleImageError} data-sentry-element="Image" data-sentry-source-file="LearnMoreWithVisualsSection.tsx" />
            </ClientOnly>
          </Box>

          {/* Gradient Overlay */}
          <Box position="absolute" top={0} left={0} width="100%" height="100%" background="linear-gradient(to bottom, rgba(255, 255, 255, 0.25) 50%, rgba(255, 255, 255, 1) 88.611%)" data-sentry-element="Box" data-sentry-source-file="LearnMoreWithVisualsSection.tsx" />
        </Box>

        {/* Load More Button */}
        <Button width="100%" height="40px" borderRadius={8} border="1px solid" borderColor="primary.600" background="transparent" color="primary.600" textStyle={{
        base: 'label.small',
        tablet: 'label.large'
      }} fontWeight="normal" onClick={handleLoadMore} _hover={{
        background: 'primary.50'
      }} _active={{
        background: 'primary.100'
      }} data-sentry-element="Button" data-sentry-source-file="LearnMoreWithVisualsSection.tsx">
          Load More
        </Button>
      </VStack>
    </SectionContainer>;
};
export default LearnMoreWithVisualsSection;